export const API_V1 = '/v1';
export const API_V2 = '/v2';
